import { ISessionResponse } from '@kcftech/prometheus-client';
import {
    QueryObserverResult,
    skipToken,
    UseQueryOptions,
    useQuery,
} from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

/**
 * Loads a session. Returns `undefined` if `sessionId` is undefined.
 *
 * @param sessionId The id of the session to load.
 */
export function useSession(
    sessionId: string | undefined,
    options?: UseQueryOptions<ISessionResponse | undefined>,
): QueryObserverResult<ISessionResponse | undefined, unknown> {
    return useQuery({
        queryKey: ['workbench-session', sessionId],

        queryFn:
            !sessionId || sessionId === ''
                ? skipToken
                : async () => sdClient.getSession({ id: sessionId }),

        ...options,
    });
}
